import { useTheme } from '@mui/material';
import { ECMCertificate } from '~/adapters/services/accounts/taxExemptionsECM/types';

export type TaxExemptionInternalStatus = 'Valid' | 'Expired' | 'Invalid' | 'Pending';

interface StatusTranslateResult {
    status: TaxExemptionInternalStatus;
    color: string;
    tooltipMessage?: string;
}

export const useInternalStatus = (certificate: ECMCertificate): StatusTranslateResult => {
    const theme = useTheme();

    if (certificate.status === 'COMPLETE' && certificate.expirationAt <= new Date()) {
        return {
            status: 'Expired',
            color: theme.palette.error.main,
            tooltipMessage:
                'This certificate is no longer valid. Please add a new certificate to update your tax-exempt status.',
        };
    }
    if (!certificate.valid) {
        return {
            status: 'Invalid',
            color: theme.palette.error.main,
            tooltipMessage:
                'This certificate is invalid. If you think this is an error, start a new application in the portal.',
        };
    }
    if (certificate.status === 'COMPLETE') {
        return {
            status: 'Valid',
            color: theme.palette.success.main,
            tooltipMessage: 'You are able to make qualifying tax-exempt purchases in this state.',
        };
    }
    return {
        status: 'Pending',
        color: theme.palette.info.main,
        tooltipMessage:
            'Your tax exemption status is waiting for verification. Please review your application in the portal.',
    };
};
